import {getCollection} from '@account/api/features.js';
import {parseAccessibilityZoneRefs} from '@account/utils/az-geometry';
import {useQueries} from '@tanstack/react-query';

export const useAccessibilityZoneCollections = azRefs => {
  const parsed = parseAccessibilityZoneRefs(azRefs);

  const queries = useQueries({
    queries: parsed.map(({dataset, collectionId}) => ({
      queryKey: ['featureCollections', collectionId],
      queryFn: () => getCollection(collectionId, dataset),
      enabled: parsed.length > 0,
      // Only used for the collection bbox (map fit) — that's static, so never
      // treat it as stale and refetch.
      staleTime: Infinity,
    })),
  });

  const isLoading = queries.some(q => q.isLoading);
  const isError = queries.every(q => q.isError) && queries.length > 0;
  // Some (but not all) collections failed — callers can surface a partial
  // warning while still rendering the collections that did load.
  const isPartialError =
    queries.some(q => q.isError) && !isError && queries.length > 0;
  const collections = queries.filter(q => q.data).map(q => q.data);

  return {collections, isLoading, isError, isPartialError};
};
